var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.breadcrumbs.length)?_c('ul',{staticClass:"flex list-reset items-center mb-3"},_vm._l((_vm.breadcrumbs),function(ref,index){
var name = ref.name;
var path = ref.path;
var title = ref.title;
var icon = ref.icon;
return _c('li',{key:index,staticClass:"flex"},[_c('div',{staticClass:"flex items-center"},[(icon)?_c('div',[_c('fa-icon',{staticClass:"text-grey-dark mr-4",attrs:{"icon":icon}})],1):_vm._e(),_c('router-link',{staticClass:"text-grey-dark text-xs hover:text-brand",class:{ 'font-bold': index === 0, 'uppercase': index > 0 },attrs:{"to":{ name: name }}},[_vm._v("\n          "+_vm._s(title)+"\n        ")])],1)])})):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }